module.exports = __webpack_public_path__ + "assets/img/net_mgr_switch.ade7e2c9.png";